// extracted by mini-css-extract-plugin
export default {"imageWrapper":"YO-z","twoColumnImage":"ZO-z"};